import {all, fork, takeLatest} from 'redux-saga/effects';
import createServiceAssignmentMedicalAdviceFlow from './sagas/createServiceAssignmentMedicalAdviceFlow';
import updateSAMARequirements from './sagas/updateSAMARequirements';
import updateSAMAServiceLocationFlow from './sagas/updateSAMAServiceLocationFlow';
import selectSAMAServiceProviderFlow from './sagas/selectSAMAServiceProviderFlow';
import searchSAMADoctorLocations from './sagas/searchSAMADoctorLocations';
import samaMapDoctorLocationWatcher from './sagas/samaMapDoctorLocationWatcher';
import * as samaActionTypes from './samaActionTypes';
import updateSAMACommissioningFlow from './sagas/updateSAMACommissioningFlow';
import searchSAMAServiceProviders from './sagas/searchSAMAServiceProviders';
import samaMapServiceProviderWatcher from './sagas/samaMapServiceProviderWatcher';
import config from '../config';
import searchSAMAServiceProvidersGoogleMaps from './sagas/searchSAMAServiceProvidersGoogleMaps';
import searchSAMADoctorLocationsGoogleMaps from './sagas/searchSAMADoctorLocationsGoogleMaps';

/**
 *  SAMA watcher saga
 */
const samaWatcher = function* samaWatcher() {
    yield all([
        fork(createServiceAssignmentMedicalAdviceFlow),
        fork(updateSAMARequirements),
        fork(updateSAMAServiceLocationFlow),
        fork(selectSAMAServiceProviderFlow),
        fork(samaMapDoctorLocationWatcher),
        fork(updateSAMACommissioningFlow),
        ...(!config.IS_FALLBACK_SYSTEM ? [fork(searchSAMAServiceProviders)] : []),
        fork(samaMapServiceProviderWatcher),
        fork(searchSAMAServiceProvidersGoogleMaps),
        takeLatest(samaActionTypes.SEARCH_SAMA_DOCTOR_LOCATIONS, searchSAMADoctorLocations),
        takeLatest(samaActionTypes.SEARCH_SAMA_DOCTOR_LOCATIONS_GOOGLE_MAPS, searchSAMADoctorLocationsGoogleMaps),
    ]);
};

export default samaWatcher;
